<div class="chip-list-wrapper">
  <div class="chip-row">
    <mat-chip-listbox #chipList aria-label="Active filter items" selectable="false" [tabIndex]="-1" role="group">
      <mat-chip-option (removed)="removeFilterItem(chip)" variant="outlined" *ngFor="let chip of filterChips | slice:0:4; let i=index" aria-readonly="true" role="listitem" tabIndex="-1" [attr.aria-label]="chip.name">{{ chip.name }}
        <button [attr.aria-label]="'remove ' + chip.name + ' filter'" matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-option>
    </mat-chip-listbox>

    <!-- Expand/Collapse Button -->
    <div class="button-wrapper">
      <a
    *ngIf="filterChips.length > 0"
    mat-button
    class="expand-button"
    [attr.aria-label]="'open filter menu'"
    (click)="drawer.toggle()"
  >
    {{ filterChips.length + ' Filters Selected' }}
    </a>
    <!-- Clear all Button -->
    <button
      *ngIf="filterChips.length > 0"
      mat-button
      class="clear-button"
      [attr.aria-label]="'clear filters'"
      (click)="clearAllFilters()"
    >
      {{ 'Clear All' }}
    </button>
  </div>
    </div>
</div>
